import { useState, useCallback, useEffect } from "react"
import { client } from "@lib/api"
import * as Sentry from "@sentry/react"

type Source = 'REDEMPTION' | 'PAYMENT'

const useFavoritePaymentBanks = (source: Source = 'PAYMENT') => {
    const [favorites, setFavorites] = useState<Set<string>>(new Set())

    useEffect(() => {
        const url = source === 'PAYMENT' ? '/wallet/bankings/payment' : '/wallet/bankings'
        client.doGet<{ bank_uuid: string; is_favorite: boolean }[]>(url)
            .then(list => {
                setFavorites(
                    new Set(list.filter(b => b.is_favorite).map(b => b.bank_uuid))
                )
            })
            .catch(Sentry.captureException)
    }, [source])

    const toggleFavorite = useCallback((bankId: string) => {
        setFavorites(prev => {
            const previous = new Set(prev)
            const next = new Set(prev)
            const newValue = !next.has(bankId)
            if (newValue) {
                next.add(bankId)
            } else {
                next.delete(bankId)
            }
            client.doPatch(`/v2/wallet/banking/${bankId}/favorite`, { is_favorite: newValue })
                .catch((err) => {
                    setFavorites(previous)
                    Sentry.captureException(err)
                })
            return next
        })
    }, [])

    const isFavorite = useCallback((bankId: string) => favorites.has(bankId), [favorites])

    return { isFavorite, toggleFavorite }
}

export default useFavoritePaymentBanks
